
/* eslint-disable */
import { CoordinatesPosition, DesktopRoomObject, Room, RoomObject, User, zawaroom } from '@/utils/models';
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { isAdminOrRoomAdmin } from '@/utils/functions';

@Component({ components: {} })
export default class RoomObjectMenu extends Vue {
  @Prop() room!: Room;
  @Prop() roomObject!: RoomObject | DesktopRoomObject;
  // @Prop() private scale!: number;
  @Prop() canEdit?: boolean;

  // @Emit() maximizeRequest() {
  //   return this.screenRect;
  // }
  @Emit() private editBoard(ro: RoomObject) {}
  @Emit() private deleteObject(object: RoomObject | DesktopRoomObject) {}
  @Emit() private unlockRequest() {}
  @Emit() private lockRequest() {}
  @Emit() applyBoardSetting(obj: RoomObject, imageFile: null, forceUpdate: boolean) {}
  @Emit() onPointerEnterSetObject(ev: PointerEvent, roomObject: RoomObject | DesktopRoomObject) {}
  @Emit() onPointerLeaveClearObject(roomObject: RoomObject | DesktopRoomObject) {}

  unlockEventTimer: any = 0;
  subWindow: Window | null = null;

  // private get screenRect(): { width: number; height: number } {
  //   let ro = this.roomObject as DesktopRoomObject;
  //   let videoTrackEl = ro.userParticipant?.desktopTrack;
  //   if (videoTrackEl?.el) {
  //     const vel = videoTrackEl.el as HTMLVideoElement;
  //     const rect = vel.getBoundingClientRect();
  //     const width = Math.round(rect.width / this.scale);
  //     const height = Math.round(rect.height / this.scale);
  //     return { width, height };
  //   }
  //   return { width: this.size, height: this.size };
  // }
  // get size(): number {
  //   return this.roomObject.size ?? 100;
  // }
  get isImage(): boolean {
    return (
      this.roomObject.objectType === 'image' ||
      (this.roomObject.objectType === 'board' && this.roomObject.props.boardType === 'image')
    );
  }
  get isIframe(): boolean {
    return this.roomObject.objectType === 'board' && this.roomObject.props.boardType === 'iframe';
  }
  get isShareScreen(): boolean {
    return this.roomObject.objectType === 'share screen';
  }
  get isBoard(): boolean {
    return this.roomObject.objectType === 'board';
  }
  get isLocked(): boolean {
    return this.roomObject.isLocked ?? false;
  }
  get isCheckedRoomTypeAll() {
    return this.roomObject.roomType === 'all';
  }
  get user(): User {
    return this.$store.state.user;
  }
  get isOwner(): boolean {
    return this.roomObject.createdUserId === this.user.id;
  }
  get isAdminOrRoomAdmin(): boolean {
    return isAdminOrRoomAdmin(this.user, this.room);
  }
  get author(): string {
    return this.roomObject.createdUserName;
  }
  get isRoomObjectHover(): boolean {
    return this.$store.state.isRoomObjectHover;
  }

  openImgInDifferentTab(): void {
    if (!this.isRoomObjectHover) {
      return;
    }
    if (this.subWindow && !this.subWindow.closed) {
      this.subWindow.focus();
      return;
    }
    this.subWindow?.close();
    this.subWindow = null;

    if (this.roomObject.objectType === 'image' || this.roomObject.props?.boardType === 'image') {
      const newTab = window.open();
      if (newTab) {
        let url = this.roomObject.imageBase64 ?? '';
        if (url.startsWith('/')) {
          url = location.origin + url;
        }
        newTab.document.body.innerHTML = `<img src="${url}" />`;
        this.subWindow = newTab;
      }
    } else if (this.roomObject.props?.boardType === 'iframe') {
      let url = this.roomObject.props.iframeUrl ?? '';
      if (url.startsWith('/')) {
        url = location.origin + url;
      }
      const newTab = window.open(url, '_blank');
      newTab?.focus();
    } else if (this.roomObject.objectType === 'share screen') {
      let ro = this.roomObject as DesktopRoomObject;
      let videoTrackInfo = ro.createdUserParticipant?.desktopTrack;
      if (!videoTrackInfo) {
        return;
      }
      if (zawaroom.jitsi?.currentOpeningTrack) {
        console.warn('処理中のトラックが存在します。');
      }
      if (zawaroom.jitsi) {
        zawaroom.jitsi.currentOpeningTrack = { track: videoTrackInfo.track, name: this.author };
      }
      let windowFeatures = 'popup';
      const newTab = window.open('sharescreen.html', videoTrackInfo.track.getId(), windowFeatures);
      if (newTab) {
        this.subWindow = newTab;
      }
    }
  }
  onEditBoard() {
    if (!this.isRoomObjectHover) {
      return;
    }
    this.editBoard(this.roomObject);
  }
  onRemoveObject(): void {
    if (!this.isRoomObjectHover) {
      return;
    }
    this.deleteObject(this.roomObject);
  }
  onLockClicked() {
    if (!this.isRoomObjectHover) {
      return;
    }
    this.lockRequest();
  }
  onUnlockStart() {
    if (!this.isLocked || this.unlockEventTimer) {
      return;
    }
    this.unlockEventTimer = setTimeout(() => {
      this.unlockRequest();
      this.unlockEventTimer = 0;
    }, 300);
  }
  onUnlockRelease() {
    if (this.unlockEventTimer) {
      clearTimeout(this.unlockEventTimer);
      this.unlockEventTimer = 0;
    }
  }
  updateRoomObjectAndStore() {
    this.roomObject.roomType = this.roomObject.roomType === 'all' ? 'subroom' : 'all';
    this.applyBoardSetting(this.roomObject, null, true);
  }
}
